import { EChartsOption } from 'echarts/types/dist/shared';

export const calculatorChartOptions: EChartsOption = {
  legend: {
    align: 'left',
    itemStyle: {
      borderColor: '#333',
      borderType: 'solid',
      borderWidth: 1
    },
    orient: 'vertical',
    right: '0',
    selectedMode: false,
    textStyle: {
      color: '#333',
      overflow: 'break',
      width: '100'
    },
    top: 'middle',
    width: '50%'
  },
  series: [
    {
      avoidLabelOverlap: true,
      center: ['50%', '50%'],
      data: [],
      label: {
        show: false
      },
      labelLine: {
        show: false
      },
      radius: ['80%', '95%'],
      type: 'pie',
      width: '50%'
    }
  ]
};
